export const toSectionId = (heading: string) =>
  heading
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '');
